import React, { createContext, useContext, useState, useEffect } from "react";
import md5 from "md5";

interface IChangePasswordContext {
	previousPass: string;
	setPreviousPass: React.Dispatch<React.SetStateAction<string>>;
	previousPassHashed: string;
	setPreviousPassHashed: React.Dispatch<React.SetStateAction<string>>;
	newPass: string;
	setNewPass: React.Dispatch<React.SetStateAction<string>>;
	newPassHashed: string;
	setNewPassHashed: React.Dispatch<React.SetStateAction<string>>;
	cambiandoPass: boolean;
	setCambiandoPass: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ChangePasswordContext = createContext({} as IChangePasswordContext);
export const useChangePasswordContext = () => useContext(ChangePasswordContext);

const Provider = ({ children }) => {
	const [previousPass, setPreviousPass] = useState("");
	const [previousPassHashed, setPreviousPassHashed] = useState("");
	const [newPass, setNewPass] = useState("");
	const [newPassHashed, setNewPassHashed] = useState("");
	const [cambiandoPass, setCambiandoPass] = useState(false);

	useEffect(() => {
		let disposed = false;

		(async () => {
			if (disposed) return;
			if (newPass.length > 3) {
				const _hash = md5(newPass);
				setNewPassHashed(_hash.replaceAll("/", ""));
			}
		})();

		return () => {
			disposed = true;
		};
	}, [newPass]);

	useEffect(() => {
		let disposed = false;

		(async () => {
			if (disposed) return;
			if (previousPass.length > 3) {
				const _hash = md5(previousPass);
				setPreviousPassHashed(_hash.replaceAll("/", ""));
			}
		})();

		return () => {
			disposed = true;
		};
	}, [previousPass]);

	const value = {
		previousPass,
		setPreviousPass,
		previousPassHashed,
		setPreviousPassHashed,
		newPass,
		setNewPass,
		newPassHashed,
		setNewPassHashed,
		cambiandoPass,
		setCambiandoPass,
	};

	return <ChangePasswordContext.Provider value={value}>{children}</ChangePasswordContext.Provider>;
};

const obj = {
	Provider,
	Consumer: ChangePasswordContext.Consumer,
};

export default obj;
